import { render, staticRenderFns } from "./PermissionTransportSpecialistImporter.vue?vue&type=template&id=18e4ad78&scoped=true"
import script from "./PermissionTransportSpecialistImporter.vue?vue&type=script&lang=js"
export * from "./PermissionTransportSpecialistImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4ad78",
  null
  
)

export default component.exports